class Function {
    constructor(_identity, _request) {
        this.request = _request;
        this.identity = _identity;
    }

    details() {
        return this.request.fetch({
            method: "GET",
            endpoint: `functions/${this.identity}`
        });
    }

    update(_data) {
        return this.request.fetch({
            method: "PUT",
            endpoint: `functions/${this.identity}`,
            params: _data
        });
    }

    delete() {
        return this.request.fetch({
            method: "DELETE",
            endpoint: `functions/${this.identity}`
        });
    }

}

export default Function;